<template>
  <el-container class="serviceItems-box" direction="vertical">
    <div class="search-x">
      <div class="search-item">
        <span class="label">服务项目</span>
        <el-input
          placeholder="项目名称、项目ID"
          class="input-box"
          clearable
          v-model.trim="form.keyword"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">服务类别</span>
        <el-cascader
          placeholder="请选择服务类别"
          clearable
          v-model="form.serviceTypes"
          :options="serviceTypeList"
          :props="{
            value: 'id',
            label: 'name',
            emitPath: false,
            multiple: true,
          }"
        ></el-cascader>
      </div>
      <div class="search-item">
        <span class="label">服务提供方式</span>
        <el-select
          v-model="form.serviceModeId"
          clearable
          :placeholder="'请选择'"
        >
          <el-option
            v-for="el in serviceModeList"
            :label="el.name"
            :value="el.id"
            :key="el.id"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">权益类别</span>
        <el-select v-model="form.rightType" clearable :placeholder="'请选择'">
          <el-option label="类别1" value="1"></el-option>
          <el-option label="类别2" value="2"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">状态</span>
        <el-select v-model="form.status" clearable :placeholder="'请选择'">
          <el-option label="启用" value="ON"></el-option>
          <el-option label="停用" value="OFF"></el-option>
        </el-select>
      </div>

      <div class="search-item">
        <!-- <span class="label">供应商</span> -->
        <span class="label">关联"供应商-服务项目"</span>
        <el-cascader
          :props="{
            multiple: true,
            value: 'id',
            label: 'serviceName',
            children: 'serviceList',
            emitPath: false,
          }"
          clearable
          v-model="form.serviceIds"
          placeholder="请选择供应商服务"
          :options="cascaderOptions"
          :show-all-levels="false"
        ></el-cascader>
      </div>

      <el-button
        class="search-btn"
        v-auth="'sa_item_page'"
        type="primary"
        @click="getData(true)"
        >查询</el-button
      >
      <el-button
        class="search-btn"
        v-auth="'sa_item_page'"
        type="primary"
        @click="() => ($root.showPage = false)"
        >重置</el-button
      >
      <el-button
        class="search-btn"
        v-auth="'sa_item_create'"
        type="warning"
        @click="toPage('serviceItemsAdd')"
        >新建</el-button
      >
      <!-- <el-button type="primary" @click="() => (visible = true)"
                >批量导入</el-button
            > -->
      <el-button class="search-btn" type="primary" @click="exportService"
        >批量导出</el-button
      >
    </div>
    <div class="table-x" ref="tableBox">
      <el-table
        min-height="500"
        v-loading="loading"
        :data="tableData"
        :height="tableHeight"
        border
        class="mb20"
      >
        <el-table-column type="index" align="center" label="序号" width="100">
          <template slot-scope="scope">
            {{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          width="100"
          align="center"
          label="服务项目ID"
        >
        </el-table-column>
        <el-table-column
          prop="itemCode"
          width="125"
          align="center"
          label="服务项目编码"
        >
        </el-table-column>
        <el-table-column
          prop="itemName"
          width="110"
          align="center"
          label="服务项目名称"
        >
        </el-table-column>
        <el-table-column
          type="index"
          align="center"
          label="服务类别"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.serviceType | filterValue(serviceTypeList) }}
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          align="center"
          label="服务提供方式"
          width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.parentModeName }}
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          align="center"
          label="权益类别"
          width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.childrenModeName }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="200"
          label="关联“供应商-服务项目”"
        >
          <template slot-scope="scope">
            <el-tooltip>
              <div slot="content">
                <p
                  v-for="(item, index) in scope.row.services.split(',')"
                  :key="index"
                >
                  {{ item }}
                </p>
              </div>
              <div class="table-services">
                {{ scope.row.services }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="155"
          align="center"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column prop="itemStatus" align="center" label="状态">
          <template slot-scope="scope">
            {{ scope.row.itemStatus | statusFilter }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                v-auth="'sa_item_view'"
                size="middle"
                class="mb10"
                type="text"
                @click="
                  toPage('serviceItemsDetail', {
                    id: scope.row.id,
                  })
                "
                >查看</el-button
              >
              <el-button
                v-auth="'sa_item_edit'"
                size="middle"
                class="mb10"
                type="text"
                @click="
                  toPage('serviceItemsEdit', {
                    id: scope.row.id,
                  })
                "
                >编辑</el-button
              >
              <el-button
                v-auth="'sa_item_status'"
                size="middle"
                class="mb10"
                type="text"
                @click="toOnOrOff(scope.row)"
              >
                <span v-if="scope.row.itemStatus === 'ON'">停用</span>
                <span v-if="scope.row.itemStatus === 'OFF'">启用</span>
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @size-change="getData"
          @current-change="getData"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :page-sizes="[10, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          background
        >
        </el-pagination>
      </div>
    </div>
    <!-- <Upload v-model="visible" @getData="getData" /> -->
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import getService from "@/mixins/getService.mixin";
import { dateFormat } from "@/assets/js/until.js";
// import Upload from "./components/upLoad.vue";
import _ from "loadsh";
export default {
  name: "serviceItems",
  // components: { Upload },
  data() {
    return {
      /**
       * 表单相关
       */
      // 查询条件
      form: { rightType: "" }, // form 信息
      supplierList: [], //供应商
      /**
       * 表格相关
       */
      loading: true,
      // 页数相关信息
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      tableData: [], // 表格数据
      tableHeight: 0, // 表格高度
      /**
       * 其他
       */
      visible: false, // 上传组件visible
      serviceModeList: [], // 服务提供方式列表
      cascaderOptions: [], // 供应商服务列表
    };
  },
  mixins: [getService],
  computed: {
    ...mapGetters(["authMap", "userName"]),
  },

  methods: {
    //窗口改变，重新取得高度
    listenWindow() {
      this.tableHeight = this.$refs.tableBox.offsetHeight;
      window.addEventListener("resize", () => {
        clearTimeout(this.resizeFlag);
        this.resizeFlag = setTimeout(() => {
          try {
            this.tableHeight = this.$refs.tableBox.offsetHeight || 0;
          } catch (e) {}
        }, 300);
      });
    },
    /**
     * 跳转页面
     */
    toPage(name, query = {}) {
      this.$router.push({ name, query });
    },
    /**
     * 启用停用确认操作
     */
    async toOnOrOff(item) {
      let tips = `您是否确定${item.itemStatus == "ON" ? "停用" : "启用"}?`;
      if (item.itemStatus == "ON") {
        let res = await this.axios.get(
          this.getApiUrl("itemServiceStatusCheck"),
          {
            params: {
              itemId: item.id,
            },
          }
        );
        let data = res.data || {};
        if (data.isConnect && item.itemStatus == "ON")
          tips = "当前服务存在有效的权益订单，是否确定停用?";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.itemServiceStatus(item);
        })
        .catch(() => {});
    },
    /**
     * 启用，停用
     */
    async itemServiceStatus(item) {
      this.loading = true;
      let data = {
        id: item.id,
        status: {
          ON: "OFF",
          OFF: "ON",
        }[item.itemStatus],
      };
      let res = await this.axios.post(
        this.getApiUrl("itemServiceStatus"),
        data,
        {
          toJSON: true,
        }
      );
      await this.getData();
      if (res.code === 1) this.$message.success("操作成功");
      else this.$message.error(res.msg);
      this.loading = false;
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = {};
      this.$forceUpdate();
    },
    /**
     * 获取数据
     */
    async getData(resetPage) {
      if (resetPage === true) this.page.pageNo = 1;
      this.loading = true;
      let param = Object.assign({}, this.form, this.page);
      Object.keys(param).forEach((key) => {
        if (Object.prototype.toString.call(param[key]) === "[object Array]") {
          param[key] =
            param[key].length == 1 ? param[key][0] : param[key].join(",");
        }
      });
      let res = await this.axios.get(this.getApiUrl("itemServicePage"), {
        params: param,
      });
      this.tableData = res?.data?.data || [];
      this.page.pageSize = res?.data?.pageSize;
      this.page.pageNo = res?.data?.pageNo;
      this.page.total = res?.data?.total;
      this.loading = false;
    },
    /**
     * 获取供应商列表
     */
    async getSupplierList() {
      let res = await this.axios.get(this.getApiUrl("providerPage"), {
        params: {
          pageNo: 1,
          pageSize: 1000,
        },
      });
      this.supplierList = res?.data?.data || [];
    },
    /**
     * 服务提供方式
     */
    async getProvisionData() {
      // 接口请求
      let res = await this.axios.get(this.getApiUrl("serviceModeTree"), {});
      if (res.code === 1) {
        this.serviceModeList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    /**
     * 获取供应商服务list
     */
    async getCascaderOptions() {
      let res = await this.axios.get(this.getApiUrl("itemServiceList"), {
        params: {},
      });
      let data = res?.data || [];
      data.forEach((item) => {
        if (item.providerName) item.serviceName = item.providerName;
      });
      this.cascaderOptions = data; // 测试数据
    },
    // 导出供应商
    exportService() {
      let urlPath = this.getApiUrl("itemServiceExport");
      let date = dateFormat(new Date());
      let param = this.$root.optionProcess(
        JSON.parse(JSON.stringify(this.form))
      );
      let fileName = `服务项目信息${date.replace(/-/g, "").slice(0, 8)}${
        this.userName
      }`;
      this.$root.exportFile(urlPath, param, fileName);
    },
  },
  filters: {
    // serviceTypeFilter(id, serviceTypeList) {
    // 	if (!serviceTypeList?.length || !id) return "";
    // 	let data = { parentName: "", children: "" };
    // 	serviceTypeList.forEach((el) => {
    // 		data.parentName = el.name;
    // 		if (el.id == id) {
    // 			data = el;
    // 		}
    // 		if (el?.children?.length) {
    // 			el.children.forEach((e) => {
    // 				if (e.parentId == id) data.children = e;
    // 			});
    // 		}
    // 	});

    // 	return data?.parentName + " - " + data?.children.name;
    // },
    filterValue(text, data) {
      let addName = {};

      data.forEach((item) => {
        if (text == item.id) {
          addName.name = item.name;
        }
        _.get(item, "children", []).forEach((list) => {
          if (text == list.id) {
            addName.name = item.name;
            addName.childrenName = list.name;
          }
        });
      });
      if (_.get(addName, "childrenName")) {
        return addName?.name + "-" + _.get(addName, "childrenName", "");
      } else if (_.get(addName, "name")) {
        return addName?.name;
      } else {
        return "";
      }
    },
    /**
     * 服务类型filter
     */

    /**
     * 状态
     */
    statusFilter(text) {
      let t = text;
      switch (text) {
        case "ON":
          t = "启用";
          break;
        case "OFF":
          t = "停用";
          break;
      }
      return t;
    },
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "服务项目", link: "" },
      { name: "服务项目管理", link: "" },
    ];
  },
  mounted() {
    if (!this.authMap["sa_item_page"]) {
      this.loading = false;
      this.$message.error("抱歉，您暂无权限");
      return;
    }
    this.$nextTick(() => {
      this.listenWindow();
      this.getSupplierList(); // 获取供应商列表
      this.getCascaderOptions(); // 获取供应商服务list
      this.getProvisionData(); // 获取服务提供方式
      this.getData(); // 获取数据
    });
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
.serviceItems-box {
  .search-x {
    min-height: 120px;
    flex-shrink: 0;
  }
  // .cont-x {
  //     flex: 1;
  //     flex-shrink: 0;
  // }
  // .table-services {
  //     width: 100%;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     display: -webkit-box;
  //     -webkit-box-orient: vertical;
  //     -webkit-line-clamp: 4; /*行数*/
  //     // white-space: nowrap;
  // }
}
</style>
